// extracted by mini-css-extract-plugin
export default {"menu":"SidebarMenu_menu__XKZIB","MuiDrawerPaper":"SidebarMenu_MuiDrawerPaper__t8q0j"};